/**
 * EmbedAuthHandler
 *
 * Wird geladen wenn das HeyKiki-Portal den iFrame öffnet:
 *   crm.werkpilot.de/?embed=1&module=kunden&token=JWT
 *
 * Flow:
 * 1. Token aus URL auslesen und in localStorage speichern
 * 2. Redirect zum gewünschten Modul mit ?embed=1
 */

import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const MODULE_ROUTES = {
  kunden: '/kunden',
  anfragen: '/anfragen',
  termine: '/kalender',
  kalender: '/kalender',
  angebote: '/kostenvoranschlaege',
  kostenvoranschlaege: '/kostenvoranschlaege',
  rechnungen: '/rechnungen',
  dashboard: '/dashboard',
  projekte: '/projekte',
  'ki-zentrale': '/ki-zentrale',
  kiZentrale: '/ki-zentrale',
  einstellungen: '/einstellungen',
  katalog: '/katalog',
  mitarbeiter: '/mitarbeiter',
};

export default function EmbedAuthHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const module = searchParams.get('module') || 'dashboard';
    const isEmbed = searchParams.get('embed') === '1';

    if (!isEmbed) return;

    // Token in localStorage speichern (selber Key wie reguläre Auth)
    if (token) {
      localStorage.setItem('token', token);
    }

    // Zum gewünschten Modul navigieren
    const route = MODULE_ROUTES[module] || '/dashboard';
    navigate(`${route}?embed=1`, { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  );
}
